/* eslint-disable import/order */
import PropTypes from 'prop-types';
// @mui
import { Box, Grid, Card, Link, Avatar, IconButton, Typography, InputAdornment, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
// components
import Iconify from '../../../../components/Iconify';
import InputStyle from '../../../../components/InputStyle';
import { useEffect, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import useIsMountedRef from 'hooks/useIsMountedRef';
import axios, { getErrorMessage } from 'utils/axios';
import CRUD from 'utils/Crud';
import { DataGrid } from '@mui/x-data-grid';
import { fDate, fDateTime } from 'utils/formatTime';
import { useSnackbar } from 'notistack';
import Label from 'components/Label';
import { fNumber } from 'utils/formatNumber';
// @mui
import { useTheme } from '@mui/material/styles';
import { sentenceCase } from 'change-case';
// ----------------------------------------------------------------------


UserTransactions.propTypes = {
  user: PropTypes.object,
};


export default function UserTransactions({ user }) {

  const isMountedRef = useIsMountedRef();
  const [sort, setSort] = useState({field:'id', order:'desc'});
  const [data, setData] = useState({data:[],current_page:1,total_pages:null,total_size:0,page_size:0});
  const [state,setState] = useState({loading:false,loadComplete:false,error:null});
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();

  // const updateData = (k, v) => setData((prev) => ({ ...prev, [k]: v }));
  
  useEffect(() => {
    getInitData();
  }, []);

  return (
    <Box sx={{ mt: 1 }}>
      <Card sx={{padding:3}}>
        <Typography variant="h4" sx={{ mb: 3 }}>
          Transaction History
        </Typography>

          <Box sx={{display:"flex", alignContent:"right", justifyContent:"end", width:"100%", padding:2}}>
            <FormControl sx={{ml:2,width:180}}>
              <InputLabel id="demo-simple-select-label2">Sort order</InputLabel>
              <Select
                labelId="demo-simple-select-label2"
                label="Sort order"
                value={sort.order}
                onChange={(e)=> setSort({...sort,order:e.target.value})}
              >
                {[
                  {v:'asc',n:"Ascending"},
                  {v:'desc',n:"Descending"},
                  ].map((opt,i) => (
                <MenuItem key={i} value={opt.v}>{opt.n}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <LoadingButton loading={state.loading} onClick={()=> getInitData()}
              sx={{ml:2}} variant='outlined' color="secondary">
                Apply changes
            </LoadingButton> 
            
          </Box>

          <Box sx={{ height: 600, width: '100%', mt:3 }}>
              <DataGrid
                rows={data.data}
                columns={[
                  
                  {
                      field: 'transaction_id',
                      headerName: 'Transaction I.D',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'amount',
                      headerName: 'Amount',
                      width: 180,
                      editable: false,
                      valueGetter: (params) => `${params.row.currency}${fNumber(params.value)}`,
                      renderCell: (params) => {
                        const color = (params.row.action_type === 'outgoing' && 'error') || 'primary';
                        return <Label
                                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                  color={color} >
                              {params.row.currency}{fNumber(params.value)}
                            </Label>
                      },
                    },
                    {
                      field: 'action_type',
                      headerName: 'Type',
                      width: 180,
                      editable: false,
                    },
                    // {
                    //   field: 'fee',
                    //   headerName: 'Fee',
                    //   width: 180,
                    //   editable: false,
                    //   valueGetter: (params) => `${params.row.currency}${fNumber(params.value)}`,
                    //   renderCell: (params) => <Label
                    //               variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                    //               color={'error'} >
                    //           {params.row.currency}{fNumber(params.value)}
                    //         </Label>,
                    // },
                    // {
                    //   field: 'settled_amount',
                    //   headerName: 'Settled amount',
                    //   width: 180,
                    //   editable: false,
                    //   valueGetter: (params) => `${params.row.currency}${fNumber(params.value)}`,
                    // },
                    {
                      field: 'status',
                      headerName: 'Status',
                      width: 180,
                      editable: false,
                      renderCell: (params) => {
                        let color = (params.value === 'failed' && 'error') || 'secondary';
                        if(params.value === "successful"){
                          color = 'success';
                        } else if(params.value === "successfulPending"){
                          color = 'primary';
                        }
                        else if(params.value === "rejected"){
                          color = 'warning';
                        }
                        return <Label 
                                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                  color={color} >
                              {sentenceCase(params.value)}
                            </Label>
                      },
                      valueGetter: (params) => params.row.status
                    },
                    {
                      field: 'status_msg',
                      headerName: 'Status msg',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'source_name',
                      headerName: 'Source name',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'source_identifier',
                      headerName: 'Source identifier',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'source_channel',
                      headerName: 'Source channel',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'source_institution_name',
                      headerName: 'Source institution name',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'source_institution_id',
                      headerName: 'Source institution I.D',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'beneficiary_name',
                      headerName: 'Beneficiary name',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'beneficiary_identifier',
                      headerName: 'Beneficiary identifier',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'beneficiary_channel',
                      headerName: 'Beneficiary channel',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'beneficiary_institution_id',
                      headerName: 'Beneficiary institution I.D',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'beneficiary_institution_name',
                      headerName: 'Beneficiary institution name',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'beneficiary_label_id',
                      headerName: 'Beneficiary label id',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'beneficiary_label_name',
                      headerName: 'Beneficiary label name',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'beneficiary_label_name',
                      headerName: 'Beneficiary label name',
                      width: 180,
                      editable: false,
                    },
                    {
                      field: 'beneficiary_label_value',
                      headerName: 'Beneficiary label value',
                      width: 180,
                      editable: false,
                    },
                    
                    {
                      field: 'updated_at',
                      headerName: 'Updated at',
                      width: 180,
                      editable: false,
                      valueGetter: (params) => fDate(params.value),
                    },
                    {
                      field: 'created_at',
                      headerName: 'Created at',
                      width: 180,
                      editable: false,
                      valueGetter: (params) => fDate(params.value),
                    },
                ]} 

                paginationMode="server"
                rowCount={data.total_size}
                page={data.current_page - 1}
                rowsPerPage={data.data.length}
                onPageChange={(newPage)=> {
                  setSort({...sort, page:newPage + 1});
                  getInitData(newPage + 1);
                }}
                pageSize={data.page_size}
                onPageSizeChange={(newPage) => setSort({...sort, page:newPage})}
                rowsPerPageOptions={[]}
                
              />
            </Box>
      </Card>

    </Box>
  );

  
  async function getInitData() {
    // alert("here");
    if(data.data.length > 0){
      setData({...data,data:[]});
    }
    setState({...state,loading:true,loadComplete:false,error:null});

    try {
      
      const str = `?sort_order=${sort.order}&page=${state.page}&user_id=${user.user_id}`;

      const response = await axios.get(CRUD.user.transactions+str);

      if (isMountedRef.current) {
        setData(response.data);
      }
      setState({...state,loading:false,loadComplete:true,error:null})
    } catch (error) {
      // console.error(error); getErrorMessage(error)
      enqueueSnackbar(getErrorMessage(error));
      setState({...state,loading:false,loadComplete:false});
    }
  };
}
